import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellLabel.styles';
import { Label, Typography } from '../../../base-components';
import { LabelColor } from '../../../base-components/Label/types';
import { EMPTY_CELL } from '../../../../common';

interface Props extends IBaseCellsProps {
    data: { labelText: string; labelColor: LabelColor };
}
const CellLabel = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        data,
    } = props;
    const { labelText, labelColor } = data;

    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            {labelText ? (
                <Label
                    color={labelColor}
                    colorVariant={'light'}
                    sx={{ borderRadius: '11px', width: '93px' }}
                >
                    {labelText}
                </Label>
            ) : (
                <Typography variant={'body2'}>{EMPTY_CELL}</Typography>
            )}
        </StyledTableCell>
    );
};

export default CellLabel;
